import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BaryButtonComponent, BaryInputPasswordComponent, BaryInputTextComponent } from '../../../../components';
import { AsFormControlPipe } from '../../../../../pipes/as-form-control.pipe';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryValidator } from '../../../../../../validators/bary.validator';
import { AccountService } from '../../../../../../services/account.service';
import { AlertService } from '../../../../../../services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordStrengthBarComponent } from '../../../../components/password-strength-bar/password-strength-bar.component';

@Component({
  selector: 'jhi-modal-change-password',
  standalone: true,
  templateUrl: './modal-change-password.component.html',
  imports: [
    TranslateDirective,
    TranslateModule,
    DatePipe,
    BaryInputTextComponent,
    BaryButtonComponent,
    AsFormControlPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BaryInputPasswordComponent,
    PasswordStrengthBarComponent,
  ],
})
export class ModalChangePasswordComponent {
  readonly #accountService = inject(AccountService);
  readonly #modalRef = inject(MDBModalRef);
  readonly #translateService = inject(TranslateService);
  readonly #alertService = inject(AlertService);
  readonly #spinnerService = inject(NgxSpinnerService);

  public passwordForm = new FormGroup(
    {
      currentPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
    },
    { validators: BaryValidator.passwordMatchValidator() }
  );

  public handleClick(): void {
    this.#modalRef.hide();
  }

  public handleSubmit(): void {
    this.#spinnerService.show();
    this.#accountService
      .updatePassword(this.passwordForm.get(['newPassword'])!.value, this.passwordForm.get(['currentPassword'])!.value)
      .subscribe({
        next: (): void => {
          this.#alertService.addAlert({
            type: 'success',
            message: this.#translateService.instant('MODAL.CHANGE_PASSWORD.SUCCESS'),
          });
        },
        error: (): void => {
          this.#alertService.addAlert({
            type: 'danger',
            message: this.#translateService.instant('MODAL.CHANGE_PASSWORD.ERROR'),
          });
        },
      })
      .add((): void => {
        this.#spinnerService.hide();
        this.handleClick();
      });
  }
}
